import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'

// axios.defaults.baseURL = 'http://localhost:8000'
// axios.defaults.baseURL = 'https://test.movigooapp.com/gateway/recording'
// axios.defaults.baseURL = 'https://movigooapp.com/gateway/recording'
axios.defaults.baseURL = 'https://evaluatorst-back.movigooapp.com'

// Vue.prototype.$http = axios

Vue.use(VueAxios, axios)

// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// library.add(faUserSecret)

Vue.component('font-awesome-icon', FontAwesomeIcon)


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import FlashMessage from '@smartweb/vue-flash-message'
Vue.use(FlashMessage)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);


import VModal from 'vue-js-modal'
Vue.use(VModal, {
  dialog: true,
  dynamic: true,
});

import Datepicker from 'vuejs-datepicker';
Vue.component("date-picker", Datepicker)


import VueGoodTablePlugin from 'vue-good-table';

// import the styles
import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTablePlugin);

// import Vuetify from 'vuetify';
// import 'vuetify/dist/vuetify.min.css';

// Vue.use(Vuetify);

import AudioVisual from 'vue-audio-visual'

Vue.use(AudioVisual)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
